import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Row, Col, Form, Button, Alert, Card } from "react-bootstrap";
import { signUp, resetSignUp ,bitGetsignUp, signIn} from "../../actions/auth-action";
import { Redirect, useHistory } from "react-router-dom";
import useInput from "../hooks/useInput";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import "./BitgetSignup.scss";
import { BitgetRefCode } from "../../Const";
import { SIGN_OUT, SIGN_UP_ERROR } from "../../actions/types";

const BitGetSignUp = (props) => {
  const { signUp, resetSignUp,signIn } = props;
  const { search } = useLocation();
  const location = useLocation();
  const query = queryString.parse(search);
  const dispatch = useDispatch()
  const signUpError = useSelector((state) => state.auth.signUpError);
  const signUpRedirect = useSelector((state) => state.auth.signUpRedirect);
  const signUpStart = useSelector((state) => state.auth.signUpStart);
  const signUpSuccess = useSelector((state) => state.auth.signUpSuccess);

  useEffect(() => {
    dispatch({
      type: SIGN_OUT,
    });
  }, []);

  const errorMessage = useSelector((state) => state.auth.errorMessage);
  const signInStart = useSelector((state) => state.auth.signInStart);
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const history = useHistory();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [bitgetAccId, setBitgetAccId] = useState("");
  const [chEmail, setChEmail] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [checked, setChecked] = useState(false);
  const [referralCode, bindReferralCode] = useInput(query.ref || "ch");
  const [acc, accType] = useInput(query.acc ||"false");
  const pathname = (location.state && location.state.from) || "/dashboard";
  const gaConfirmed = useSelector((state) => state.auth.gaConfirmed);
  const gaEnabled = useSelector((state) => state.settings.gaEnabled);
  useEffect(() => {
    resetSignUp();
    return () => {
      resetSignUp();
    };
  }, [resetSignUp]);

  if (token && acc=="true") {
    if (user && user.email_verified_at) {
      if (gaEnabled && !gaConfirmed) return <Redirect to="/ga/confirm" />;
      return <Redirect to={pathname} />;
    }
    return <Redirect to="/verify-otp" />;
  }
  const clickSignUp = (e) => {
    e.preventDefault();
      if(acc=="true"){
        if (bitgetAccId == null || bitgetAccId === "") {
          return dispatch({
            type: SIGN_UP_ERROR,
            payload: "Please input Bitget Account ID",
          });
        }
        signIn(chEmail,password,{
          partner: "bitget",
          bitget_account: bitgetAccId,
        });
      }
      else{
        signUp({
          first_name: firstName,
          last_name: lastName,
          email,
          password,
          password_confirmation: confirmPass,
          from: "web",
          partner: "bitget",
          bitget_account: bitgetAccId,
        });
      }
      
  }
  if (signUpRedirect) {
    return <Redirect to="/verify-otp" />;
  }
  return (
    <div className="bitget-signup">
      <Row>
        <Col className="left-panel left-col-bg-bitget">
         
          <div className="bitget-trading">
           
          </div>
        </Col>
        <Col className="right-panel">
        
          <div className="signup-panel">
            <Form>
            {acc=="false" ?
            <>
            <h6 className="mt-2 header-text">Register for Bitget x ForexHero Competition</h6>
              <Form.Group className="mandala-form">
                <Form.Control
                  as="input"
                  placeholder="First name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mandala-form">
                <Form.Control
                  as="input"
                  placeholder="Last name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mandala-form">
                <Form.Control
                  as="input"
                  placeholder="Your Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mandala-form">
                <Form.Control
                  as="input"
                  placeholder="Password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mandala-form">
                <Form.Control
                  as="input"
                  placeholder="Repeat password"
                  type="password"
                  value={confirmPass}
                  onChange={(e) => setConfirmPass(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="ch-form">
                  <Form.Control
                    as="input"
                    // type="number"
                    placeholder="Your Bitget Account ID"
                    value={bitgetAccId}
                    onChange={(e) => setBitgetAccId(e.target.value)}
                  />
              </Form.Group>
              </> :<>
              <h6 className="mt-2 header-text">Register for Bitget x ForexHero Competition</h6>
              <Form.Group className="ch-form">
                <Form.Control
                  as="input"
                  placeholder="Your ForexHero Account Email"
                  type="email"
                  value={chEmail}
                  onChange={(e) => setChEmail(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mandala-form">
                <Form.Control
                  as="input"
                  placeholder="Your ForexHero Account Password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="ch-form">
                  <Form.Control
                    as="input"
                    // type="number"
                    placeholder="Your Bitget Account ID"
                    value={bitgetAccId}
                    onChange={(e) => setBitgetAccId(e.target.value)}
                  />
              </Form.Group>
               </>
              }
              <Form.Check
                label={
                  <p>
                     I agree to release my trading data to <a className="terms-mandala"
                      href="https://www.bitget.com/en/"
                      target="_blank"
                    >Bitget </a>for this competition
                  </p>
                }
                className="terms"
                value={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
              <div className="my-3">
                <Button
                  type="submit"
                  onClick={clickSignUp}
                  className={"mandala-button"}
                  disabled={!checked}
                >
                  {(signUpStart || signInStart) ? "SUBMITTING..." : "REGISTER"}
                </Button>
                <div className="mt-3">
                {acc=="false"?
                <p><a href="?acc=true" className="header-color mt-5">Click Here </a>If you already have a ForexHero Account</p>:
                <p><a href="?acc=false" className="header-color mt-5">Click Here </a>If you do not have a ForexHero Account</p>
                }
                </div>
               
                {/* <Button
                  type="submit"
                  onClick={() => history.push("/dashboard")}
                  className={"mandala-button-login"}
                >
                  LOGIN
                </Button> */}
              </div>
              {(signUpError || signUpSuccess) && 
              <Alert
                show={signUpError || signUpSuccess}
                variant={signUpSuccess ? "success" : "danger"}
                className="mt-2"
              >
                {signUpError || signUpSuccess}
              </Alert> }
              {(errorMessage) && 
              <Alert
                show={errorMessage != null}
                variant="danger"
                className="mt-2"
              >
                {errorMessage && errorMessage}
              </Alert> }
            </Form>
            
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default connect(null, { signUp, resetSignUp,signIn })(BitGetSignUp);
